const getError = (error, tips = 'unknown error.')=>(error instanceof Error || error instanceof DOMException ? error : void 0) ?? ('string' == typeof error ? new Error(error) : void 0) ?? new Error(error instanceof Object && 'message' in error && 'string' == typeof error.message ? error.message : tips, {
        cause: error
    });
const isKey = (key, data)=>isPropertyKey(key) && key in data;
const isPropertyKey = (value)=>[
        'number',
        'string',
        'symbol'
    ].includes(typeof value);
const objectValues = (obj)=>Object.values(obj);
function promiseTryPolyfill(fn, ...args) {
    try {
        return Promise.resolve(fn(...args));
    } catch (error) {
        return Promise.reject(getError(error));
    }
}
const ProxyPromise = new Proxy(Promise, {
    get (target, propKey) {
        if ('try' === propKey) return 'try' in target ? target.try : promiseTryPolyfill;
        return target[propKey];
    }
});
export { ProxyPromise, getError, isKey, isPropertyKey, objectValues };
